import isStringSet from '../is/isStringSet';
import { AES, enc } from 'crypto-js';
import packageInfo from 'settings.json';

const { store } = packageInfo;

class InMemoryStorage {
    
    _backingStore = {};
    _keys = [];

    getItem(key) {
        return this._backingStore[key];
    }

    setItem(key, value) {
        const index = this._keys.indexOf(key);
        if (index === -1)
            this._keys.push(key);

        this._backingStore[key] = value;
    }

    get length() {
        return this._keys.length;
    }

    key(index) {
        return this._keys[index];
    }

    removeItem(key) {
        delete this._backingStore[key];
        this._keys = this._keys.filter(k => k !== key);
    }

    clear() {
        this._keys = [];
        this._backingStore = {};
    }
}

function encrypt(message) {
    if (!store.encryption.enabled) {
        return message;
    }

    if (message === null) return null;
    const value = AES.encrypt(message, store.encryption.key);
    return value.toString();
}

function decrypt(encrypted) {
    if (!store.encryption.enabled) {
        return encrypted;
    }

    if (encrypted === null) return "";
    try {
        const value = AES.decrypt(encrypted, store.encryption.key);
        return value.toString(enc.Utf8);
    } catch (e) {
        console.error(e);
        return "";
    }
}

export class AppStore {

    constructor() {
        try {
            this._storage = sessionStorage;
        } catch(e) {
            this._storage = new InMemoryStorage();
        }
    }    

    get(key) {
        const json = decrypt(this._storage.getItem(key));
        if (isStringSet(json)) {
            return JSON.parse(json);
        }

        return null;
    }

    set(key, value) {
        if (!isStringSet(key)) {
            throw Error("key must be provided");
        }

        this._storage.setItem(key, encrypt(JSON.stringify(value)));
    }

    keys() {
        const allKeys = [];

        for (let i = 0, l = this._storage.length; i < l; i++) {
            allKeys.push(this._storage.key(i));
        }

        return allKeys;
    }

    hasKey(key) {
        return this._storage.getItem(key) !== null;
    }

    remove(key) {
        this._storage.removeItem(key);
    }

    clear() {
        this._storage.clear();
    }
}

// Singleton, default return for module
const appStore = new AppStore();

export default appStore;
